import React, { useEffect, useState } from 'react';
import {
  Cell,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip as RechartsTooltip,
  Label,
} from 'recharts';
import UseGetDashBoardData from '../../../../Components/Hooks/useDashboardData';
import UseGetDashBoardWithParams from '../../../../Components/Hooks/useDashboardDataParams';
import { useNavigate } from 'react-router-dom';
import { Pointer } from 'lucide-react';
import { GetAccess } from '../../../../Components/Utils/roles';

function InvoiceYear() {
    const currentYear = new Date().getFullYear();
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [overviewData, setOverviewData] = useState([]);
    const [params, setParams] = useState({
     
      year: currentYear,
    });
  const { data, loading } = UseGetDashBoardWithParams(`/dashboard/invoice-out/chart`,params);
 
 useEffect(() => {
    if (data && Array.isArray(data)) {
      setOverviewData(data);
    }
  }, [data]);

   const handleYearChange = (e) => {
    const newYear = e.target.value;
    setParams({ ...params, year: newYear });
    setSelectedYear(newYear);
  };
  const chartData = data?.data?.map((item) => ({
    name: item.label,
    value: item.count,
    status: item.status,
  })) || [];

  const COLORS = ['#987D9A', '#6C946F', '#FFB200', '#77E4C8', '#E6703E', '#5891C8'];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="max-w-[350px] bg-white shadow-md rounded-lg p-[5px]">
          <p className="text-xs font-medium">{`${payload[0].name} : ${payload[0].value}`}</p>
        </div>
      );
    }
    return null;
  };
  const navigate = useNavigate();

  const handleSliceClick = (status) => {
    const path = '/invoice/invoice-outgoing';
 console.log('Status',status);
 
 navigate(path , {state: { status : status } });
};

  
 
  return (
    <div className="col-span-2 bg-white h-[50vh] 2xl:h-[54vh] w-full p-4 rounded-2xl shadow-lg">
      <div className="w-full px-1 py-[2px] flex justify-between items-center p-4">
        <h3 className="text-gray-700 text-sm font-bold mb-1">Invoice</h3>
        <select
            value={selectedYear}
            onChange={handleYearChange}
            className="border rounded-md p-1 text-xs text-[#ACACAC] font-normal"
          >
            {[...Array(10)].map((_, index) => (
              <option key={index} value={currentYear - 5 + index}>
                {currentYear - 5 + index}
              </option>
            ))}
          </select>
      </div>

      <div className="border-t border-[1px] border-slate-200/60 w-full mt-2"></div>

      {loading ? (
        <LoadingSkeleton />
      ) : (
        <div className="h-[98%] overflow-y-scroll">
          <div className="flex">
            {chartData.some((item) => item.value > 0) ? (
              <div className="w-[40%] flex justify-center items-center group transition-all duration-300 hover:scale-105">
                <ResponsiveContainer width="100%" height={160}>
                  <PieChart>
                    <Pie
                      data={chartData}
                      cx="50%"
                      cy="50%"
                      innerRadius={35}
                      outerRadius={60}
                      fill="#8884d8"
                      dataKey="value"
                     cursor="pointer"
                      onClick={GetAccess('invoice_out_view')  ?(e) => handleSliceClick(e.status): undefined}
                    >
                      {chartData.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={COLORS[index % COLORS.length]}
                          onFocus={(e) => e.target.blur()}
                        />
                      ))}
                      <Label
                        value={data?.total || 0}
                        position="center"
                        style={{ fontSize: '12px', fontWeight: 'bold', fill: '#4F4768' }}
                      />
                    </Pie>
                    <RechartsTooltip content={<CustomTooltip />} />
                  </PieChart>
                </ResponsiveContainer>
              </div>
            ) : (
              <NODataChart />
            )}

            <div className="w-[60%] flex flex-col justify-center px-2 overflow-y-scroll">
              {chartData.map((item, index) => (
                <div className="flex items-center text-xs mb-2" key={index}>
                  <span
                    className="inline-block w-3 h-3 rounded-full mr-2"
                    style={{
                      background: `linear-gradient(45deg, ${COLORS[index % COLORS.length]}, #ffffff)`,
                      border: '1px solid #ccc',
                    }}
                  ></span>
                  <p className="w-[45%] text-[#4F4768]">{item.name}</p>
                  <p className="w-[15%] text-[#4F4768]">: {item.value}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function LoadingSkeleton() {
  return (
    <div className="flex w-full h-full space-y-4 animate-pulse">
      <div className="w-[40%] flex justify-center">
        <NODataChart />
      </div>
      <div className="w-[60%] flex flex-col mt-4 space-y-2">
        <div className="w-1/2 h-4 bg-slate-200 rounded"></div>
        <div className="w-1/3 h-4 bg-slate-200 rounded"></div>
        <div className="w-1/2 h-4 bg-slate-200 rounded"></div>
        <div className="w-1/3 h-4 bg-slate-200 rounded"></div>
      </div>
    </div>
  );
}

function NODataChart() {
  return (
    <div className="w-[40%]">
      <div className="w-full flex justify-center">
        <ResponsiveContainer width="100%" height={150}>
          <PieChart>
            <Pie
              data={[{ name: 'No Data', value: 100 }]}
              cx="50%"
              cy="50%"
              innerRadius={30}
              outerRadius={50}
              fill="#E8E8E8"
              dataKey="value"
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default InvoiceYear;
